var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-nav"},[_c(_setup.ContentPad,[_c('div',{staticClass:"header-block"},_vm._l((_vm.list),function(tab,index){return _c('div',{key:index,staticClass:"nav-font",class:{
					'nav-font--current': _setup.isCurrentPage(tab),
					'nav-font--other': !_setup.isCurrentPage(tab)
				},on:{"click":function($event){return _setup.handleNavClick(tab, index)}}},[(index)?_c('i',{staticClass:"iconfont icon-flip-right"}):_vm._e(),_c('span',[_vm._v(_vm._s(_setup.formattedNavTitle(tab)))])])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }